'use client';
import React, { useState } from 'react';
import DashboardSidebar from '@/components/DashboardSidebar';
import DashboardTopbar from './DashboardTopbar';
import KPIBentoGrid from './KPIBentoGrid';
import BookingChartsRow from './BookingChartsRow';
import BookingsTable from './BookingsTable';

export default function DashboardLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <DashboardSidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <DashboardTopbar />
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-12 py-6 flex flex-col gap-6">
            {/* Page Header */}
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-700 text-foreground">Booking Dashboard</h1>
                <p className="text-sm text-muted-foreground mt-0.5">Tuesday, May 12, 2026 · Last updated 2 minutes ago</p>
              </div>
              <a
                href="/"
                className="btn-primary text-sm flex items-center gap-2"
              >
                + New Booking
              </a>
            </div>

            <KPIBentoGrid />
            <BookingChartsRow />
            <BookingsTable />
          </div>
        </main>
      </div>
    </div>
  );
}